import { useSelector } from 'react-redux';

export const PatientName = ({ patientName }: { patientName?: string }) => {
  const displayPhi = useSelector((state: any) => state.login?.user?.privacyOn);

  if (displayPhi || !patientName) {
    return (
      <div className="vai-text-left vai-underline vai-font-light">
        {patientName}
      </div>
    );
  }
  const name = patientName.split(' ');

  return (
    <span className="vai-text-wrap vai-gap-1 vai-text-left vai-underline vai-font-light">
      {name.map(
        (i, index) =>
          i.length > 0 && (
            <div className="vai-inline-flex vai-items-center " key={index}>
              <span className="vai-inline-block">{i[0]}</span>
              <span className="vai-text-gray-200 vai-rounded-md vai-blur-[5px] vai-select-none vai-text-xl">
                &#x2588;&#x2588;
              </span>
            </div>
          ),
      )}
    </span>
  );
};
